module.exports = __webpack_public_path__ + "img/convertshape-2.588b2955.svg";